import React from 'react';
import TextFieldInput from '../Text';

import './index.scss';

export default function Instagram(props) {
    const {onBlur} = props;

    const onBlurHandler = e => {
        console.log('check is valid');
        if (onBlur) onBlur(e);
    }

    props.field.options = props.field.options || {};
    props.field.options.regexp = '^[A-Za-z0-9_\.\-]*$';

    return <TextFieldInput
        {...props}
        onBlur={onBlurHandler}
        prefix="@"
    />
}
